@let computedPreview = (previewContent$ | async) ?? '' | linky;
@let preview = computedPreview || ('INBOX.EMPTY.CONVERSATION_PREVIEW' | translate);

<span [innerHTML]="preview"></span>
